import { useStaticQuery, graphql } from "gatsby";
import { ImageDataLike } from "gatsby-plugin-image";

export const usePlayIcon = (): ImageDataLike => {
  const playIcon = useStaticQuery(graphql`
    {
      image: file(name: { eq: "playicon" }, extension: { eq: "webp" }) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
      }
    }
  `);

  return playIcon.image;
};
